import React, { useEffect, useState, memo } from 'react';
import { Save } from 'lucide-react';
import { useForm, useFieldArray } from 'react-hook-form';
import toast from 'react-hot-toast';
import LoadingSpinner from '../components/LoadingSpinner'; // pastikan komponen ini ada
import { contentAPI } from '../services/api'; // sesuaikan ini dengan API service kamu

const Pendaftaran = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [pendaftaranData, setPendaftaranData] = useState(null);

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors }
  } = useForm({
    defaultValues: {
      title: '',
      subtitle: '',
      deskripsi: [],
      link: ''
    }
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'deskripsi'
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await contentAPI.getPendaftaran(); // pastikan method API ini ada
      const data = res?.data?.pendaftaran;
      setPendaftaranData(data);
      if (data) reset(data);
    } catch (error) {
      console.error('Gagal memuat data pendaftaran:', error);
      toast.error('Gagal memuat data');
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = async (data) => {
    setSaving(true);
    try {
      if (pendaftaranData?._id) {
        await contentAPI.updatePendaftaran(pendaftaranData._id, data);
        toast.success('Pendaftaran berhasil diperbarui');
      } else {
        await contentAPI.createPendaftaran(data);
        toast.success('Pendaftaran berhasil dibuat');
      }
      fetchData();
    } catch (error) {
      console.error('Gagal menyimpan:', error);
      toast.error('Gagal menyimpan data');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="header-page">Pendaftaran</h1>
          <p className="description-page">Kelola konten halaman pendaftaran</p>
        </div>
        <button
          onClick={handleSubmit(onSubmit)}
          disabled={saving}
          className="btn btn-primary"
        >
          {saving ? <LoadingSpinner size="sm" /> : <Save className="w-4 h-4 mr-2" />}
          {saving ? 'Saving...' : 'Save Changes'}
        </button>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="space-y-8">
        <div className="card">
          <div className="card-header">
            <h3 className="card-title">Informasi Pendaftaran</h3>
            <p className="card-description">Judul, subjudul, deskripsi dan link formulir</p>
          </div>

          <div className="card-content space-y-4">
            {/* Judul */}
            <div>
              <label className="block text-sm font-medium mb-2">Judul</label>
              <input
                {...register('title', { required: 'Judul wajib diisi' })}
                className="input"
                placeholder="Contoh: Pendaftaran Dibuka!!"
              />
              {errors.title && <p className="text-red-500 text-sm mt-1">{errors.title.message}</p>}
            </div>

            {/* Subjudul */}
            <div>
              <label className="block text-sm font-medium mb-2">Subjudul</label>
              <input
                {...register('subtitle', { required: 'Subjudul wajib diisi' })}
                className="input"
                placeholder="Contoh: Pendaftaran anggota sie 1 ketaqwaan 2025/2026"
              />
              {errors.subtitle && <p className="text-red-500 text-sm mt-1">{errors.subtitle.message}</p>}
            </div>

            {/* Deskripsi (Dinamis) */}
            <div>
              <label className="block text-sm font-medium mb-2">Deskripsi</label>
              {fields.map((field, index) => (
                <div key={field.id} className="flex items-center gap-2 mb-2">
                  <input
                    {...register(`deskripsi.${index}`, { required: 'Deskripsi tidak boleh kosong' })}
                    className="input w-full"
                    placeholder={`Deskripsi ${index + 1}`}
                  />
                  <button
                    type="button"
                    onClick={() => remove(index)}
                    className="text-red-500 text-sm"
                  >
                    Hapus
                  </button>
                </div>
              ))}
              <button
                type="button"
                onClick={() => append('')}
                className="text-sm text-blue-600 mt-2"
              >
                + Tambah Deskripsi
              </button>
              {errors.deskripsi && <p className="text-red-500 text-sm mt-1">Deskripsi wajib diisi</p>}
            </div>

            {/* Link */}
            <div>
              <label className="block text-sm font-medium mb-2">Link Formulir</label>
              <input
                {...register('link', { required: 'Link wajib diisi' })}
                className="input"
                placeholder="https://bit.ly/..."
              />
              {errors.link && <p className="text-red-500 text-sm mt-1">{errors.link.message}</p>}
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default memo(Pendaftaran);
